<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination 
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler"
        @saveTags="saveTagsHandler" />
    </template>
    <template slot="table-component">
    <kendo-grid-component
        ref="grid"
        v-model="selected"
        :value-key="['IdFlujoAprobacion']"
        :include-key="['Activo']"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @actionclick='openPath'
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive v-if="false" mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel'
            :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel" />
          <base-button-responsive mode="primary" :text="$t('approval_workflow.new')" icon="plus"
            @click="goToNewWorkflow" :loading="isGeneralLoading" />
        </template>
      </base-footer>
      <base-table-select-actions-expand :visibility="hasSelected" :selected="rowsSelected" :total="rowsTotal" :baseDropDownVisible="getAccionesPosibles.length > 0">
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" />
              {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <Dialog :title="$t('approval_workflow.delete_approval_workflows_singular')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessagedeleteWorkflow }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { deleteHandler(); showModal = false }" />
          </div>
        </template>
      </Dialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog :numberSearches="numberSearches" :idVista="idVista" :dialogOpen="saveSearchDialog"
        :tags="tags" @toggleDialog="toggleDialogSearches" @applyDialog="applySearchHandler" />
      <filter-panel-searches ref="filterPanelSearches" :idVista="idVista" :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel" @togglePanel="toggleSearchesDialog" @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches" />
    </template> 
  </list-layout>
</template>
<script>
import { i18n } from '@/i18n'
import { Dialog } from 'element-ui'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/WorkflowFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'

import { getWorkflowPag } from '@/services/configurations/workflow/getWorkflowPag'
import { deleteWorkflow } from '@/services/configurations/workflow/deleteWorkflow'
import { updateStateWorkflow } from '@/services/configurations/workflow/updateStateWorkflow'

export default {
  name: 'approval-workflows',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    Dialog,
  },
  data () {
    return {
      idVista: 96,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('approval_workflow.header'),
        icon: 'config',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'workflow',
      hasClientFilterData: false,
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 0, Descripcion: i18n.t('app.remove') }
      ],
      processMessagedeleteWorkflow: i18n.t('app.delete_selected_confirmation', { entity: i18n.t('approval_workflow.entity_name').toLowerCase() }),
    }
  },
  computed: {
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    workflowSelected () {
      return this.selected[0] || null
    },
    isWorkflowActive () {
      return this.workflowSelected?.Activo || false
    },
    selectIcon: function (action) {
      return (action) =>
        action === 0 ? 'trash'
          : action === 1 ? (this.isWorkflowActive ? 'cross' : 'check')
            : 'changestatus'
    },
    getAccionesPosibles () {
      let listaAccionesFinal = this.listaAcciones.slice()

      if (this.selected.length > 1) {
        listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 0)
      } else if (this.selected.length === 1) {
        listaAccionesFinal.unshift({ IdAccion: 1, Descripcion: this.isWorkflowActive ? i18n.t('app.disable') : i18n.t('app.enable') })
      }
      return listaAccionesFinal
    },
  },
  created: async function () {
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo?.take)
    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }
    this.data = await this.applyFilters()
  },
  methods: {
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id } }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    // exportExcel: async function () {
    //   this.$store.commit('app/setLoading', true)
    //   this.loadingExcel = true
    //   const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
    //   const params = {
    //     ItemDescription: data.ItemDescription ? data.ItemDescription.value : null,
    //     UnitOfMeasure: data.UnitOfMeasure ? data.UnitOfMeasure.value : null,
    //     UnitPriceWithoutTaxMin: data.UnitPriceWithoutTaxMin ? data.UnitPriceWithoutTaxMin.value : null,
    //     UnitPriceWithoutTaxMax: data.UnitPriceWithoutTaxMax ? data.UnitPriceWithoutTaxMax.value : null,
    //     ArticleCode: data.ArticleCode ? data.ArticleCode.value : null,
    //     idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
    //     idCliente: data.empresa ? data.empresa.value?.idCliente : null,
    //   }
    //   const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
    //   try {
    //     const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
    //     const payload = { order: objOrder.order, grupos: objColumnas }
    //     if (this.hasSelected) {
    //       payload.listaIDs = this.selected
    //     }
    //     const response = await getProductsExcel(payload, params)
    //     const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
    //     const link = document.createElement('a')
    //     link.href = window.URL.createObjectURL(blob)
    //     let filename = 'productos.xlsx'
    //     filename = decodeURI(filename)
    //     link.download = filename
    //     link.click()
    //   } catch (error) {
    //     console.error(error)
    //     if (error.response?.data) {
    //       const errorText = await error.response.data.text()
    //       this.doFeedback(errorText)
    //     } else {
    //       this.doFeedback()
    //     }
    //   } finally {
    //     this.$store.commit('app/setLoading', false)
    //     this.loadingExcel = false
    //   }
    // },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const params = {
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        nombreFlujo: data.nombreFlujo ? data.nombreFlujo.value : null,
        descripcion: data.descripcion ? data.descripcion.value : null,
        activo: data.activo ? data.activo.value : null,
        fechaCreacionDesde: data.fechaCreacionDesde ? data.fechaCreacionDesde.value : null,
        fechaCreacionHasta: data.fechaCreacionHasta ? data.fechaCreacionHasta.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Flujos
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getWorkflowPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    headerCoreFiltersHandler: async function (obs) {
      if (this.isHeadCoreReady) {
        this.data = await this.applyFilters()
      }
    },
    removeAllTagsHandler: async function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    unselect: function () {
      // this.$emit('input', [])
      this.selected = []
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
    deleteWorkflow: async function () {
      this.showModal = !this.showModal
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 0) { // borrar
        this.deleteWorkflow()
      } else if (this.selectedAction.IdAccion === 1) { // activar/desactivar
        this.updateStateWorkflow()
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
      }
    },
    updateStateWorkflow: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idFlujoAprobacion: this.workflowSelected?.IdFlujoAprobacion,
          activar: !this.isWorkflowActive
        }
        const data = await updateStateWorkflow(params)
        if (data.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        } else {
          this.unselect()
          this.data = await this.applyFilters()
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idFlujoAprobacion: this.workflowSelected?.IdFlujoAprobacion
        }
        const response = await deleteWorkflow(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    openPath: function (event) {
      this.$router.push({ name: 'configurations/approvalworkflows/details', params: { id: event.dataItem.IdFlujoAprobacion } })
    },
    goToNewWorkflow () {
      this.$router.push({ name: 'configurations/approvalworkflows/details', params: { id: -1 } })
    },
    exportExcel () {
      // Implement export to Excel functionality here
    },
  }
}
</script>
